import domReady from '@wordpress/dom-ready';
import manifest from './../manifest.json';

domReady(async () => {
	const modalSelector = `.${manifest.componentJsClass}`;
	const modalElement = document.querySelector(modalSelector);

	if (!modalElement) {
		return;
	}

	const { GdprModal } = await import('./gdpr-modal');

	const modal = new GdprModal({
		modalId: 'gdpr',
		modalSelector: '.js-gdpr-modal',
		descriptionSelector: '.js-gdpr-modal-description',
		btnSelector: '.js-gdpr-modal-btn',
		btnAdvanceSelector: '.js-gdpr-modal-btn-advance',
		backdropSelector: '.js-gdpr-modal-backdrop',
		screenBasicSelector: '.js-gdpr-modal-screen-basic',
		screenAdvanceSelector: '.js-gdpr-modal-screen-advance',
		showAdvanceSelector: '.js-gdpr-modal-show-advance',
		hideAdvanceSelector: '.js-gdpr-modal-hide-advance',
		selectionParentSelector: '.js-gdpr-modal-selection-container',
		selectionSelector: '.js-gdpr-modal-selection',
		selectionInputSelector: '.js-gdpr-modal-toggle-input',
		advancedFunctionalSelector: '.js-gdpr-modal-toggle-input-functional',
		advancedMarketingSelector: '.js-gdpr-modal-toggle-input-marketing',
		openSelector: '.js-gdpr-modal-open',
		intercomWidgetSelector: '.intercom-launcher',
		intercomOffsetOnViewportsNarrowerThan: 780,
		BODY_ACTIVE_CLASS: 'is-gdpr-modal-active',
		ACTIVE_CLASS: 'is-active',
		ONLY_ADVANCED: 'is-advanced-only',
	});

	modal.init();
});
